import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, EnhancedSectionTitle } from '../../styles/sharedComponents';
import SecurityPipeline from './SecurityPipeline';
import SecurityMetrics from './SecurityMetrics';
import { SecuritySectionWrapper, SecurityDemoContainer, SecurityVisualization, DemoTitle } from './styles';

const SecuritySection: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [encryptionDemo, setEncryptionDemo] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setTimeout(() => setEncryptionDemo(true), 1000);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const interval = setInterval(() => {
        setActiveStep(prev => (prev + 1) % 4);
      }, 2500);
      return () => clearInterval(interval);
    }
  }, [isVisible]);

  return (
    <SecuritySectionWrapper id="security" ref={ref} $isVisible={isVisible}>
      <Container>
        <EnhancedSectionTitle>
          <h2>{t('security.title')}</h2>
          <p>{t('security.subtitle')}</p>
        </EnhancedSectionTitle>

        <SecurityDemoContainer>
          <SecurityVisualization>
            <DemoTitle>{t('security.demoTitle')}</DemoTitle>
            <SecurityPipeline activeStep={activeStep} encryptionDemo={encryptionDemo} />
          </SecurityVisualization>

          <SecurityMetrics encryptionDemo={encryptionDemo} />
        </SecurityDemoContainer>
      </Container>
    </SecuritySectionWrapper>
  );
};

export default SecuritySection;
